import { onMounted, readonly, ref } from "vue"
import api from "./client"

const year = ref(new Date().getFullYear())
let requested = false

function loadCopyrightYear(): void {
        if (requested || import.meta.env.VITE_EBOOK_TARGET !== "web") return
        requested = true

        void api.get<{ year: number }>("time", { timeout: 5000 })
                .then(({ data }) => {
                        if (Number.isInteger(data.year) && data.year > 0 && data.year <= 9999) {
                                year.value = data.year
                        }
                })
                .catch(() => {
                        // При недоступном сервере сохраняем год устройства без повторных запросов.
                })
}

export function useCopyrightYear() {
        onMounted(loadCopyrightYear)
        return readonly(year)
}
